import mag_feature1 from '../../assets/content/publications/mag_feature1.jpg'
import mag_feature2 from '../../assets/content/publications/mag_feature2.jpg'
import mag_feature3 from '../../assets/content/publications/mag_feature3.jpg'

const mag_featureData = [
   {id: '', img: mag_feature1, caption: ''},
   {id: '', img: mag_feature2, caption: ''},
   {id: '', img: mag_feature3, caption: ''},
]
export default mag_featureData